import React from 'react';
export function StarHalfIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.951 9.671a1 1 0 00-.807-.68l-5.7-.829L12.9 3a1.041 1.041 0 00-1.8 0L8.555 8.162l-5.7.828A1 1 0 002.3 10.7l4.123 4.02-.971 5.67A1 1 0 006.9 21.444l5.1-2.679 5.1 2.68a1 1 0 001.451-1.055l-.973-5.675L21.7 10.7a1 1 0 00.251-1.029zm-6.151 3.98a.999.999 0 00-.288.884l.72 4.2-3.769-1.98a.99.99 0 00-.463-.119V5.7l1.884 3.818a1 1 0 00.754.547l4.213.613L15.8 13.65z"
  }));
}